import Layout from '@/views/layout'

export default [
  {
    path: '/ruleCenter',
    name: 'ruleCenter',
    redirect: '/ruleCenter/basicsRule',
    component: Layout,
    meta: {
      title: '规则中心',
      icon: 'order.png',
      index: 12
    },
    children: [
      {
        path: 'basicsRule',
        name: 'basicsRule',
        meta: {
          title: '基础规则',
          id: '1637816088',
          trackName: '规则中心-基础规则'
        },
        component: () => import('@/views/ruleCenter/basicsRule')
      },
      {
        path: 'violation',
        name: 'violation',
        meta: {
          title: '油站质量分',
          id: '1657274198',
          trackName: '油站质量分菜单按钮	'
        },
        component: () => import('@/views/ruleCenter/violation')
      },
      {
        path: 'publicity',
        name: 'publicity',
        meta: {
          title: '公示通知',
          id: '1637816090',
          trackName: '规则中心-公示通知'
        },
        component: () => import('@/views/ruleCenter/publicity')
      },
      {
        path: 'opinion',
        name: 'opinion',
        meta: {
          title: '意见征集',
          id: '1637816092',
          trackName: '规则中心-意见征集'
        },
        component: () => import('@/views/ruleCenter/opinion')
      },
      {
        path: 'history',
        name: 'history',
        meta: {
          title: '历史规则',
          id: '1637816094',
          trackName: '规则中心-历史规则'
        },
        component: () => import('@/views/ruleCenter/history')
      },
      {
        path: 'detail',
        name: 'detail',
        hidden: true,
        meta: {
          title: '详情',
        },
        component: () => import('@/views/ruleCenter/detail')
      }
    ]
  }
]